import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import AjaxLoaderImg from './AjaxLoaderImg'
import { TimelineLite } from 'gsap/TimelineLite'

const AjaxLoaderOverlay = (props) => {
    const container = useRef(null)

    useEffect(() => {
        const tl = new TimelineLite()
        if (props.doShow === true) {
            tl.to(container.current, 0.2, { display: 'flex', opacity: 1 })
        } else {
            tl.to(container.current, 0.2, { display: 'none', opacity: 0 })
        }
    }, [props.doShow])

    return (
        <div
            ref={container}
            className='w-100 h-100 justify-content-center align-items-center'
            style={{ position: 'absolute', background: 'rgba(255, 255, 255, 0.6)', transition: 'all 0.2s', display: 'none' }}
        >
            <AjaxLoaderImg width={props.width} />
        </div>
    )
}

AjaxLoaderOverlay.propTypes = {
    doShow: PropTypes.bool.isRequired,
    width: PropTypes.string
}

export default AjaxLoaderOverlay



// WEBPACK FOOTER //
// ./resources/js/components/AjaxLoaderOverlay.js